import { Button, Drawer } from "antd";
import styled from "styled-components";
import { color } from "../../../resources";

export const StyledButton = styled(Button)`
    position: fixed;
    z-index: 10000;
    top: 9px;
    right: 16px;
`

export const StyledDrawer = styled(Drawer).attrs(_ => ({
    headerStyle: {
        display: 'none'
    },
    bodyStyle: {
        padding: 0,
    },
    contentWrapperStyle: {
        width: '60%'
    }
}))
`
    z-index: 999999;
    padding: 0;
`

export const ContentHeader = styled.div`
    background-color: ${color.header};
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
`